// Theme colors
export const themeColors = {
  primary: '#3874ff',
  orange: '#f5803e', // Orange for buttons
  lightOrange: '#ff9f5a',
  darkOrange: '#e06c2c'
};

// Standard field styles (including selects/dropdowns)
export const standardFieldStyles = {
  borderRadius: '0.375rem',
  transition: 'box-shadow 0.15s ease-in-out, border-color 0.15s ease-in-out'
};

// Shared styling constants for form validation
export const invalidFieldStyles = {
  borderColor: '#dc3545 !important',
  boxShadow: '0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important',
  borderRadius: '0.375rem',
  backgroundColor: 'rgba(255, 230, 230, 0.2) !important'
};

// Custom container style for invalid fields
export const invalidContainerStyles = {
  border: '2px solid #dc3545 !important',
  borderRadius: '0.375rem',
  padding: '5px',
  backgroundColor: 'rgba(255, 230, 230, 0.2) !important'
};
